(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('AssessmentHistoryDetailController', AssessmentHistoryDetailController);

  /* ngInject */
  function AssessmentHistoryDetailController($stateParams, assessmentHistoryService, sessionService, vendorService)  {
    const vm = this;

    vm.assessmentHistory = {};
    vm.id = $stateParams.id;
    vm.vendor = {};
    vm.vendorId = $stateParams.vendorId;

    activate();

    function activate() {
      getAssessmentHistory();
      getVendor();
    }

    function getAssessmentHistory() {
      assessmentHistoryService(sessionService.getAuthToken()).get({ vendorId: vm.vendorId, id: vm.id }, response => vm.assessmentHistory = response);
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.vendor = response);
    }
  }
})();
